import { createContext, useContext, ReactNode } from 'react';
import { useSessionStorage } from '../hooks/useSessionStorage';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { TEAM_MEMBERS } from '../config/team';
import { TeamMember } from '../types';

interface UserContextType {
  selectedUser: TeamMember;
  setSelectedUser: (user: TeamMember) => void;
  customSignoff: string;
  setCustomSignoff: (signoff: string) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export function UserProvider({ children }: { children: ReactNode }) {
  const [selectedUser, setSelectedUser] = useLocalStorage<TeamMember>(
    'selectedSignoffUser',
    TEAM_MEMBERS[0]
  );
  
  const [customSignoff, setCustomSignoff] = useSessionStorage<string>(
    'customEmailSignoff',
    ''
  );

  return (
    <UserContext.Provider value={{ 
      selectedUser, 
      setSelectedUser, 
      customSignoff, 
      setCustomSignoff 
    }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
} 